export default __webpack_public_path__ + "static/FS2S-InHub-97-908c3cc1eede2f1ccc1ae8197d17eb59.jpg";